<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'

/**
 * Starter component
 */
export default {
  page: {
    title: 'Starter',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: 'Operational',
      items: [
        {
          text: 'Home',
          href: '/',
        },
        {
          text: 'Activities',
          href: '/apps/activities',
        },
        {
          text: 'Operational',
          active: true,
        },
      ],
      dateRangeFilter: '',
      ops: [
        {
          no: '1',
          second_fleet: 'BG.Navareno 1',
          project: 'KPC Project - Direct Barging Sangatta',
          start_date: '1 Maret 2021 00:00',
          end_date: '8 Maret 2021 08:00',
          hours: '176 Hour',
          reason: 'Run',
          cargoLoading: '-',
          cargoUnloading: '-',
          pol: 'Asam-Asam',
          pod: 'Rembang',
          currentPosition: 'Sailing',
          remark: 'Sailing to Rembang',
          gps: '3° 34\' 28.81" S, 122° 12\' 44.42" E',
          speed: '5.00 Knots'
        },
        {
          no: '2',
          second_fleet: 'BG.Navareno 1',
          project: 'KPC Project - Direct Barging Sangatta',
          start_date: '8 Maret 2021 08:00',
          end_date: '11 Maret 2021 12:00',
          hours: '76 Hour',
          reason: 'Waiting Loading',
          cargoLoading: '-',
          cargoUnloading: '-',
          pol: 'Asam-Asam',
          pod: 'Rembang',
          currentPosition: 'In Pos Jetty',
          remark: 'Sailing to Rembang',
          gps: '',
          speed: '0.00 Knots'
        },
        {
          no: '3',
          second_fleet: 'BG.Navareno 1',
          project: 'KPC Project - Direct Barging Sangatta',
          start_date: '11 Maret 2021 12:00',
          end_date: '11 Maret 2021 14:00',
          hours: '2 Hour',
          reason: 'Run',
          cargoLoading: '-',
          cargoUnloading: '-',
          pol: 'Asam-Asam',
          pod: 'Rembang',
          currentPosition: 'Asam-Asam',
          remark: 'Proses Sandar',
          gps: '3° 34\' 28.81" S, 122° 12\' 44.42" E',
          speed: '4.00 Knots'
        },
        {
          no: '4',
          second_fleet: 'BG.Navareno 1',
          project: 'KPC Project - Direct Barging Sangatta',
          start_date: '11 Maret 2021 14:00',
          end_date: '14 Maret 2021 13:15',
          hours: '52 Hour',
          reason: 'Loading',
          cargoLoading: '3.000 Ton',
          cargoUnloading: '-',
          pol: 'Asam-Asam',
          pod: 'Rembang',
          currentPosition: 'Asam-Asam',
          remark: 'Loading',
          gps: '3° 34\' 28.81" S, 122° 12\' 44.42" E',
          speed: '0.00 Knots'
        },
        {
          no: '5',
          second_fleet: 'BG.Navareno 1',
          project: 'KPC Project - Direct Barging Sangatta',
          start_date: '14 Maret 2021 13:15',
          end_date: '14 Maret 2021 15:25',
          hours: '2 Hour 15 Minutes',
          reason: 'Run',
          cargoLoading: '-',
          cargoUnloading: '-',
          pol: 'Asam-Asam',
          pod: 'Rembang',
          currentPosition: 'Asam-Asam',
          remark: 'Manuver keluar sandar',
          gps: '3° 34\' 28.81" S, 122° 12\' 44.42" E',
          speed: '4.00 Knots'
        },
        {
          no: '6',
          second_fleet: 'BG.Navareno 1',
          project: 'KPC Project - Direct Barging Sangatta',
          start_date: '14 Maret 2021 15:25',
          end_date: '15 Maret 2021 10:00',
          hours: '19 Hour 35 Minutes',
          reason: 'Waiting Doc',
          cargoLoading: '-',
          cargoUnloading: '-',
          pol: 'Asam-Asam',
          pod: 'Rembang',
          currentPosition: 'Asam-Asam',
          remark: 'Waiting Document POL',
          gps: '3° 34\' 28.81" S, 122° 12\' 44.42" E',
          speed: '0.00 Knots'
        },
        {
          no: '7',
          second_fleet: 'BG.Navareno 1',
          project: 'KPC Project - Direct Barging Sangatta',
          start_date: '15 Maret 2021 10:00',
          end_date: '18 Maret 2021 11:40',
          hours: '75 Hour 25 Minutes',
          reason: 'Run',
          cargoLoading: '-',
          cargoUnloading: '-',
          pol: 'Asam-Asam',
          pod: 'Rembang',
          currentPosition: 'Sailing',
          remark: 'OTW Rembang',
          gps: '3° 34\' 28.81" S, 122° 12\' 44.42" E',
          speed: '4.25 Knots'
        },
      ],
      opsMatrix: [
        { no: '1', date: '1 Mei 2021 - 24 Mei 2021', run: '4,92', tech: '1,86', dock: '0,00', weather: '5,83', ops: '0,40', purch: '0,00', loading: '0,00', unloading: '0,00', docPOL: '0,00', docPOD: '1,30', crewing: '0,00', finance: '0,00' },
        { no: '2', date: '1 Mei 2021 - 24 Mei 2021', run: '4,92', tech: '1,86', dock: '0,00', weather: '5,83', ops: '0,40', purch: '0,00', loading: '0,00', unloading: '0,00', docPOL: '0,00', docPOD: '1,30', crewing: '0,00', finance: '0,00' },
        { no: '3', date: '1 Mei 2021 - 24 Mei 2021', run: '4,92', tech: '1,86', dock: '0,00', weather: '5,83', ops: '0,40', purch: '0,00', loading: '0,00', unloading: '0,00', docPOL: '0,00', docPOD: '1,30', crewing: '0,00', finance: '0,00' },
        { no: '4', date: '1 Mei 2021 - 24 Mei 2021', run: '4,92', tech: '1,86', dock: '0,00', weather: '5,83', ops: '0,40', purch: '0,00', loading: '0,00', unloading: '0,00', docPOL: '0,00', docPOD: '1,30', crewing: '0,00', finance: '0,00' }
      ]
    }
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <!-- Tab -->
    <b-row>
      <b-col lg="12">
        <b-card class="iq-mb-3">
          <b-card-text>
            <b-tabs pills justified class="navtab-bg">
              <!-- OPERATIONAL HISTORY -->
              <b-tab title="DSV.Atlas Hawk - OPERATIONAL HISTORY" active>
                <h4 class="card-title text-primary"><strong>OPERATIONAL HISTORY - DSV.Atlas Hawk</strong></h4>
                <hr>
                <b-row>
                  <b-col md="6">
                    <b-row>
                      <b-col md="6">
                        <date-picker v-model="dateRangeFilter" :lang="lang" type="date" range placeholder="Select date range"></date-picker>
                      </b-col>
                      <b-col md="6">
                        <b-button size="sm" class="btn btn-soft-info mb-3 mr-1"><feather type="filter" class="icon-dual"></feather></b-button>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col md="6" class="text-right">
                    <router-link to="">
                      <button class="btn btn-dark mb-3 mr-1"><feather type="file-text" class="icon-xs"></feather> Export</button>
                    </router-link>
                    <button class="btn btn-primary mb-3"><feather type="plus" class="icon-xs"></feather> Add Operational Data</button>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="12">
                  <hr>
                  <div class="table-responsive tableFixHead" style="height: 450px;">
                    <table class="table mb-0 table-striped table-hover" style="width: 1900px">
                      <thead class="thead-dark text-center">
                      <tr>
                        <th class="text-center" width="2%">No</th>
                        <th class="text-center" width="13%">Project</th>
                        <th class="text-center" width="6%">Start Date</th>
                        <th class="text-center" width="6%">End Date</th>
                        <th class="text-center" width="5%">Reason</th>
                        <th class="text-center" width="5%">Hours</th>
                        <th class="text-center" width="7%">Current Position</th>
                        <th class="text-center" width="11%">Remarks</th>
                        <th class="text-center" width="9%">GPS</th>
                        <th class="text-center" width="5%">Speed</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item,index) in ops" :key="index" style="font-size:10pt">
                        <td class="text-center">{{ item.no }}</td>
                        <td class="text-center">{{ item.project }}</td>
                        <td class="text-center">{{ item.start_date }}</td>
                        <td class="text-center">{{ item.end_date }}</td>
                        <td class="text-center">{{ item.reason }}</td>
                        <td class="text-center">{{ item.hours }}</td>
                        <td class="text-center">{{ item.currentPosition }}</td>
                        <td class="text-center">{{ item.remark }}</td>
                        <td class="text-center">{{ item.gps }}</td>
                        <td class="text-center">{{ item.speed }}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </b-col>
                </b-row>
                <h4 class="card-title text-primary mt-5"><strong>OPERATIONAL MATRIX - DSV.Atlas Hawk</strong></h4>
                <hr/>
                <b-row class="mt-3">
                  <b-col md="12" class="text-right">
                    <router-link to="">
                      <button class="btn btn-dark mb-3 mr-1"><feather type="file-text" class="icon-xs"></feather> Export</button>
                    </router-link>
                  </b-col>
                  <b-col md="12">
                    <div class="table-responsive">
                      <table class="table mb-0 table-striped table-hover" style="width: 2200px">
                        <thead class="text-center">
                          <tr>
                            <th>No</th>
                            <th>Date</th>
                            <th>Run</th>
                            <th>Tech</th>
                            <th>Dock</th>
                            <th>Weather</th>
                            <th>Ops</th>
                            <th>Purch</th>
                            <th>Crewing</th>
                            <th>Finance</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(opsMtx,idx) in opsMatrix" :key="idx">
                            <td class="text-center">{{ opsMtx.no }}</td>
                            <td class="text-center">{{ opsMtx.date }}</td>
                            <td class="text-center">{{ opsMtx.run }}</td>
                            <td class="text-center">{{ opsMtx.tech }}</td>
                            <td class="text-center">{{ opsMtx.dock }}</td>
                            <td class="text-center">{{ opsMtx.weather }}</td>
                            <td class="text-center">{{ opsMtx.ops }}</td>
                            <td class="text-center">{{ opsMtx.purch }}</td>
                            <td class="text-center">{{ opsMtx.crewing }}</td>
                            <td class="text-center">{{ opsMtx.finance }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </b-col>
                </b-row>
              </b-tab>
              <!-- End OPERATIONAL HISTORY -->
              <!-- HSE -->
              <b-tab title="DSV.Atlas Hawk - HSE">
                <h4 class="card-title text-primary"><strong>SAFETY PERFORMANCE INDICATOR - DSV.Atlas Hawk</strong></h4>
                <hr>
                <b-row>
                  <b-col md="6">
                    <b-row>
                      <b-col md="6">
                        <date-picker v-model="dateRangeFilter" :lang="lang" type="date" range placeholder="Select date range"></date-picker>
                      </b-col>
                      <b-col md="6">
                        <b-button size="sm" class="btn btn-soft-info mb-3 mr-1"><feather type="filter" class="icon-dual"></feather></b-button>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col md="6" class="text-right">
                    <router-link to="">
                      <button class="btn btn-dark mb-3 mr-1"><feather type="file-text" class="icon-xs"></feather> Export</button>
                    </router-link>
                    <button class="btn btn-primary mb-3"><feather type="plus" class="icon-xs"></feather> Add HSE Record</button>
                  </b-col>
                </b-row>
                <h4 class="card-title text-primary mt-5"><strong>LAGGING - DSV.Atlas Hawk</strong></h4>
                <hr/>
                <h4 class="card-title text-primary mt-5"><strong>LEADING - DSV.Atlas Hawk</strong></h4>
                <hr/>
              </b-tab>
              <!-- END HSE -->
            </b-tabs>
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>
  </Layout>
</template>
